import {
  TextField,
  RadioGroup,
  FormControlLabel,
  Radio,
} from "@mui/material";
import axios from "axios";
import {useEffect, useState} from "react";
import FormDialog from "src/components/common/FormDialog";
import UserInfo from "src/components/common/UserInfo";
import FormItem from "src/components/form-item/FormItem";
import {alert} from "src/services/alert";

/**
 * 留存权益金修改 Dialog
 * 仅操作 User.xfqLocked 字段，支持增加 / 减少
 * 独立于 /changeXfq：留存权益金由后台独立管理，不再随消费联动
 */
const XfqLockedTopupDialog = ({open, onClose, onFinish, user}) => {
  const [form, setForm] = useState({
    type: "PLUS",
    remark: "",
    amount: "",
    password: "",
  });

  useEffect(() => {
    if (open) {
      setForm({
        type: "PLUS",
        remark: "",
        amount: "",
        password: "",
      });
    }
  }, [open]);

  function handleIptChange(ki, val) {
    setForm({
      ...form,
      [ki]: val,
    });
  }

  function handleConfirm() {
    if (Number.isNaN(parseFloat(form.amount))) return alert("数量不能为空");
    axios
      .post("/user/changeXfqLocked", {
        uid: user.uid,
        ...form,
      })
      .then((res) => {
        const {code, msg} = res.data;
        if (code === 1) {
          alert(msg, "success");
          onFinish();
        } else {
          alert(msg);
        }
      })
      .catch((err) => {
        console.log("changeXfqLocked err: ", err);
      });
  }

  return (
    <FormDialog title="修改留存权益金" open={open} onClose={onClose} onConfirm={handleConfirm}>
      <FormItem title="用户" required>
        <UserInfo {...user} enablePreview={false}/>
      </FormItem>

      <FormItem title="当前留存">
        <TextField fullWidth value={user?.xfqLocked ?? 0} size="small" disabled/>
      </FormItem>

      <FormItem title="变化" required>
        <RadioGroup row name="row-radio-buttons-group" value={form.type}
                    onChange={(e) => handleIptChange("type", e.target.value)}>
          <FormControlLabel value={"PLUS"} control={<Radio/>} label="增加"/>
          <FormControlLabel value={"MINUS"} control={<Radio/>} label="减少"/>
        </RadioGroup>
      </FormItem>

      <FormItem title="变动数目" required>
        <TextField fullWidth type="number" placeholder="变动数目" autoComplete="off" id="amount" value={form.amount}
                   size="small" onChange={(e) => handleIptChange("amount", e.target.value)}/>
      </FormItem>

      <FormItem title="密码" required>
        <TextField fullWidth placeholder="密码" type="password" autoComplete="off" id="password" value={form.password}
                   size="small" onChange={(e) => handleIptChange("password", e.target.value)}/>
      </FormItem>

      <FormItem title="备注" required>
        <TextField fullWidth multiline rows={4} placeholder="备注" autoComplete="off" id="remark" value={form.remark}
                   size="small" onChange={(e) => handleIptChange("remark", e.target.value)}/>
      </FormItem>
    </FormDialog>
  );
};

export default XfqLockedTopupDialog;
